module.exports = __webpack_public_path__ + "static/media/PLI_HamburgerMenu.aa295afe.svg";